import { DataTable, Dialog, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import usePropertyBlock from "./usePropertyBlock";
import { Search } from "lucide-react";

const PropertyBlock = () => {
  const {
    onAdd,
    isMobile,
    globalFilter,
    setGlobalFilter,
    columns,
    isLoadingPropertyBlocks,
    propertyBlocks,
    openDeleteDialog,
    setOpenDeleteDialog,
    selectedRow,
    isDeletePropertyBlockPending,
    onDeleteConfirm,
    isOwner,
    openBlockDialog,
    setOpenBlockDialog,
    blockColumns,
    hasAddPermission
  } = usePropertyBlock();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Property Blocks" />
          {!isOwner && isMobile && hasAddPermission && (
            <Button onClick={onAdd} className="px-2">
              + Add Block
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isOwner && !isMobile && hasAddPermission && <Button onClick={onAdd}>+ Add Block</Button>}
        </div>
      </div>

      {/* Responsive Table */}
      {isLoadingPropertyBlocks ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={propertyBlocks?.data?.sort(
              (a: any, b: any) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            ) || []}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
          />
          <Dialog
            open={openDeleteDialog}
            setOpen={setOpenDeleteDialog}
            title={
              <div className="text-2xl font-bold text-primary">
                {"Confirmation"}
                <div className="h-1 w-[30%] bg-primary rounded-full" />
              </div>
            }
            saveText="Delete"
            saveBtnClassName="bg-red-500 text-white hover:bg-red-500 hover:text-white"
            isLoading={isDeletePropertyBlockPending}
            onSave={onDeleteConfirm}
          >
            <p className="text-sm">
              Are you sure you want to delete Property Blocks for this Community -{" "}
              <span className="font-bold text-primary">
                {selectedRow?.communityName}
              </span>
              ? This action cannot be undone
            </p>
          </Dialog>
          <Dialog
            open={openBlockDialog}
            setOpen={setOpenBlockDialog}
            title={
              <div className="text-2xl font-bold text-primary">
                {`# Blocks - ${selectedRow?.communityName}`}
                <div className="h-1 w-[30%] bg-primary rounded-full" />
              </div>
            }
            contentClassName="md:!max-w-[700px]"
            hideFooter
          >
            <DataTable
              columns={blockColumns}
              data={selectedRow?.propertyBlockDtos || (selectedRow?.blockId ? [selectedRow] : [])}
              className="shadow-none border-none p-0"
              tableWrapperClassName="p-0"
              hideFooter
            />
          </Dialog>
        </>
      )}
    </div>
  );
};

export default PropertyBlock;
